var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 4.33333C0.666504 1.9401 2.6066 0 4.99984 0H38.9998C41.3931 0 43.3332 1.9401 43.3332 4.33333V31C43.3332 33.3932 41.3931 35.3333 38.9998 35.3333H4.99984C2.6066 35.3333 0.666504 33.3932 0.666504 31V4.33333ZM4.99984 2C3.71117 2 2.6665 3.04467 2.6665 4.33333V31C2.6665 32.2887 3.71117 33.3333 4.99984 33.3333H38.9998C40.2885 33.3333 41.3332 32.2887 41.3332 31V4.33333C41.3332 3.04467 40.2885 2 38.9998 2H4.99984Z",
    fill: "#B2B9C4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1",
    cx: 10.6663,
    cy: 9.33333,
    rx: 4.33333,
    ry: 4.33333,
    fill: "#B2B9C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M6.33301 27.6667V25.6904C6.33301 25.2483 6.5086 24.8244 6.82116 24.5119L12.2093 19.1237C12.8384 18.4947 13.8506 18.4706 14.5089 19.069L15.8402 20.2793C16.4918 20.8717 17.4918 20.8549 18.1232 20.2411L27.8214 10.8122C28.4748 10.177 29.5173 10.1843 30.1617 10.8287L37.8449 18.5119C38.1574 18.8244 38.333 19.2483 38.333 19.6904V27.6667C38.333 28.5872 37.5868 29.3334 36.6663 29.3334H7.99967C7.0792 29.3334 6.33301 28.5872 6.33301 27.6667Z",
    fill: "#B2B9C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelImgIcon);
export default __webpack_public_path__ + "static/media/model-img-icon.dfaa86db748f41be7b6168ddd8796459.svg";
export { ForwardRef as ReactComponent };